<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        width: '100%',
        minHeight: '40%',
        borderTopLeftRadius: '15px',
        borderTopRightRadius: '15px',
        background: 'linear-gradient(rgb(159, 51, 132), rgb(62, 45, 76))',
        zIndex: '10001'
    }">
        <div class="content">
            <div class="middle_title">{{ $t('profile.logoutCurrAcc') }}</div>
            <div class="tip">
                {{ $t('profile.rememberPassword') }}
            </div>
            <div class="loagout_btn" @click="logOut">{{ $t('profile.toLogout') }}</div>
            <div class="cancel_btn" @click="close">{{ $t('profile.cancel') }}</div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { ref, defineExpose } from 'vue'
const show = ref(false)
const userStore = useUserStore()
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}
const logOut = () => {
    userStore.signOut()
    sessionStorage.setItem('openPromotionPopup', '');
}
defineExpose({
    open,
})

</script>
<style scoped>
.title {
    padding: 10px 25px;
    font-size: 14px;
    background-color: #ffffff0a;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
    height: 45px;
}


.van-overlay {
    background-color: #00000047;
    backdrop-filter: blur(20px) !important;
    z-index: 3000 !important;
}


.content {
    padding: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 10001;
}

.content img {
    width: 100px;
}

.middle_title {
    color: #fff;
    font-size: 15px;
    padding: 15px;
}

.tip {
    color: #ffffffa6;
    font-size: 13px;
    padding: 15px 5px;
    text-align: center;
}

.cancel_btn {
    color: #c18bb1;
    font-size: 15px;
    padding: 12px;
    width: 250px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    margin: 5px 0;
}

.loagout_btn {
    background: linear-gradient(270deg, #e150a4, #e66fc8 81%);
    border-radius: 5px;
    color: #fff;
    font-size: 15px;
    padding: 12px;
    width: 250px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    margin: 5px 0;
}
</style>